import apiClient from './api';

export const getIDSecurityGroup = (groupName) => apiClient.get(`/microsoft-graph/id-security-group/${groupName}`);

export const getUsersByIDSecurityGroup = (groupId) => apiClient.get(`/microsoft-graph/users-by-security-group/${groupId}`);